'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.JsonRestMiddleware = JsonRestMiddleware;

var _es = require('@zaibot/fsa/es5');

var _effects = require('redux-saga/effects');

var _resource = require('../resource');

var _utils = require('../utils');

var _FetchMiddleware = require('./FetchMiddleware');

var _JsonTransportMiddleware = require('./JsonTransportMiddleware');

var _RestMiddleware = require('./RestMiddleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JsonRestMiddleware(url) {
    for (var _len = arguments.length, middlewares = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        middlewares[_key - 1] = arguments[_key];
    }

    return descriptor => {
        return connectMiddleware((0, _RestMiddleware.RestMiddleware)({ id: descriptor.options.id, url: url }), ...middlewares, _JsonTransportMiddleware.JsonTransportMiddleware, _FetchMiddleware.FetchMiddleware);
    };
}
function connectMiddleware() {
    let middleware = (0, _utils.applyMiddlewares)(...arguments);
    return function* (_ref) {
        let action = _ref.action,
            descriptor = _ref.descriptor;

        if ((0, _es.isType)(action, descriptor.actions.CREATE)) {
            let context = { create: (0, _resource.stripFields)(action.payload.item) };
            try {
                yield (0, _effects.call)(middleware, context);
                if (context.ok) {
                    yield (0, _effects.put)(descriptor.actions.CREATE_SUCCESS({
                        item: (0, _extends5.default)({}, action.payload.item, context.created, (0, _defineProperty3.default)({}, _resource.fields.id, context.created[descriptor.options.id]))
                    }));
                } else {
                    yield (0, _effects.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: context.error }));
                }
            } catch (ex) {
                yield (0, _effects.put)(descriptor.actions.CREATE_FAILURE({ item: action.payload.item, reason: ex }));
            }
        } else if ((0, _es.isType)(action, descriptor.actions.READ)) {
            let context = { read: (0, _resource.stripFields)(action.payload.item) };
            try {
                yield (0, _effects.call)(middleware, context);
                if (context.ok) {
                    yield (0, _effects.put)(descriptor.actions.READ_SUCCESS({
                        item: (0, _extends5.default)({}, action.payload.item, context.readed)
                    }));
                } else {
                    yield (0, _effects.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: context.error }));
                }
            } catch (ex) {
                yield (0, _effects.put)(descriptor.actions.READ_FAILURE({ item: action.payload.item, reason: ex }));
            }
        } else if ((0, _es.isType)(action, descriptor.actions.UPDATE)) {
            let context = { update: (0, _resource.stripFields)(action.payload.item) };
            try {
                yield (0, _effects.call)(middleware, context);
                if (context.ok) {
                    yield (0, _effects.put)(descriptor.actions.UPDATE_SUCCESS({
                        item: (0, _extends5.default)({}, action.payload.item, context.updated)
                    }));
                } else {
                    yield (0, _effects.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: context.error }));
                }
            } catch (ex) {
                yield (0, _effects.put)(descriptor.actions.UPDATE_FAILURE({ item: action.payload.item, reason: ex }));
            }
        } else if ((0, _es.isType)(action, descriptor.actions.DELETE)) {
            let context = { remove: (0, _resource.stripFields)(action.payload.item) };
            try {
                yield (0, _effects.call)(middleware, context);
                if (context.ok) {
                    yield (0, _effects.put)(descriptor.actions.DELETE_SUCCESS({
                        item: (0, _extends5.default)({}, action.payload.item, context.deleted)
                    }));
                } else {
                    yield (0, _effects.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: context.error }));
                }
            } catch (ex) {
                yield (0, _effects.put)(descriptor.actions.DELETE_FAILURE({ item: action.payload.item, reason: ex }));
            }
        } else if ((0, _es.isType)(action, descriptor.actions.LIST)) {
            let context = { list: action.payload.params || {} };
            try {
                yield (0, _effects.call)(middleware, context);
                if (context.ok) {
                    yield (0, _effects.put)(descriptor.actions.LIST_SUCCESS({
                        list: context.listed.map(item => (0, _extends5.default)({}, item, (0, _defineProperty3.default)({}, _resource.fields.id, item[descriptor.options.id]))),
                        params: action.payload.params || {}
                    }));
                } else {
                    yield (0, _effects.put)(descriptor.actions.LIST_FAILURE({ reason: context.error, params: action.payload.params || {} }));
                }
            } catch (ex) {
                yield (0, _effects.put)(descriptor.actions.LIST_FAILURE({ reason: ex, params: action.payload.params || {} }));
            }
        }
    };
}
//# sourceMappingURL=JsonRestMiddleware.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/JsonRestMiddleware.js